import { MyWriting } from './MyWritingPage'
import { withMyWritingPage } from './withMyWritingPage'

const ConnectedMyWriting = withMyWritingPage(MyWriting)

export { ConnectedMyWriting as MyWritingPage }
